import React from 'react'
import { useMCProExperiment } from '../../hooks/useMCProExperiment'
import { Matrix as Variant1Matrix } from './variant1'
import { Matrix as Variant2Matrix } from './variant2'
import { Matrix as Variant3Matrix } from './variant3'

export const Matrix = () => {
  const { isVariant1, isVariant2, isVariant3 } = useMCProExperiment()

  if (isVariant1) return <Variant1Matrix />
  if (isVariant2) return <Variant2Matrix />
  if (isVariant3) return <Variant3Matrix />

  return null
}
